module.exports = __webpack_public_path__ + "img/tools_news.59329c5b.png";